import React from 'react';

const Footer = () => {
  return (
    <div className="bg-pink-600 text-white py-7 text-center">
      <div className="container mx-auto">
        <p>&copy; Shaniya Malcolm 2021</p>
      </div>
    </div>
  );
};

export default Footer;
